module.exports = __webpack_public_path__ + "static/fonts/Fact-Black.023a6d3.woff";